import { Route } from '@angular/router';
import { media } from './media';
import { offerings } from './offerings';
import { assignment } from './assignment';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { templateDatasets } from './templateDatasets';

export const content: Route = {
  path: 'content',
  title: 'nav.content',
  data: {
    icon: SbIcons.megaphone,
    breadcrumb: 'nav.content',
  },
  children: [assignment, media, offerings, templateDatasets, { path: '', redirectTo: RoutingID.assignment, pathMatch: 'full' }],
};
